import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { VersandmitteilungDialog } from "@/components/VersandmitteilungDialog";
import { fmtDateTime } from "@/lib/api";

// Knopf „Versandmitteilung senden“ / „Erneut senden“ je gebuchter Sendung mit Auftrag
export const VersandmitteilungButton = ({ s, onSent, size = "sm" }) => {
  const [open, setOpen] = useState(false);
  if (!s.order_id || s.status === "fehler") return null;
  const sent = !!s.versandmitteilung_gesendet_am;
  return (
    <>
      <Button size={size} variant={sent ? "outline" : "default"} onClick={() => setOpen(true)} data-testid={`shipment-mail-${s.id}`}
        title={sent ? `Gesendet ${fmtDateTime(s.versandmitteilung_gesendet_am)}${s.versandmitteilung_mit_rechnung ? " · mit Rechnung" : ""}` : undefined}>
        <Send className="w-4 h-4 mr-1" /> {sent ? "Erneut senden" : "Versandmitteilung senden"}
      </Button>
      <VersandmitteilungDialog shipment={s} open={open} onOpenChange={setOpen} onSent={onSent} />
    </>
  );
};
